/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

type TBoolStr = `${boolean}`;

export default class FiltersBooleanFilterComponent extends Component<FilterComponentSignature> {
  @tracked value?: TBoolStr = this.getValueAsString();

  getValueAsString(): TBoolStr | undefined {
    const { values = [] } = this.args;
    return values.length > 0 ? (values[0]!.toString() as TBoolStr) : undefined;
  }

  @action
  valueDidChange(newValue: TBoolStr) {
    this.value = newValue === this.value ? undefined : `${newValue}`;
    this.args.onChange?.(this.value ? [this.value] : []);
  }

  @action
  setValue() {
    const val = this.getValueAsString();
    if (val !== this.value) {
      this.value = val;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::BooleanFilter': typeof FiltersBooleanFilterComponent;
    'filters/boolean-filter': typeof FiltersBooleanFilterComponent;
  }
}
